import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { compatWrapper } from '@backstage/core-compat-api';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

/**
 * Dependencies content tab showing depends-on-components and
 * depends-on-resources cards in a grid layout.
 *
 * Displayed for service, website, and library components only —
 * matching the old EntityPage.tsx behaviour where documentation
 * components and the generic fallback page had no dependencies tab.
 */
const dependenciesContent = EntityContentBlueprint.make({
  name: 'dependencies',
  params: {
    path: '/dependencies',
    title: 'Dependencies',
    group: 'development',
    filter: {
      kind: 'component',
      'spec.type': { $in: ['service', 'website', 'library'] },
    },
    loader: async () => {
      const { Grid } = await import('@material-ui/core');
      const { EntityDependsOnComponentsCard, EntityDependsOnResourcesCard } =
        await import('@backstage/plugin-catalog');

      return compatWrapper(
        <Grid container spacing={3} alignItems="stretch">
          <Grid item md={6}>
            <EntityDependsOnComponentsCard />
          </Grid>
          <Grid item md={6}>
            <EntityDependsOnResourcesCard />
          </Grid>
        </Grid>,
      );
    },
  },
});

export const dependenciesContentModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [dependenciesContent],
});
